import { createFileRoute } from "@tanstack/react-router";
import ErrorState from "src/components/ErrorState";

export const Route = createFileRoute("/_auth")({
  staticData: {
    title: "Trader Sage",
  },
  errorComponent: ({ error }) => <ErrorState error={error} />,
});
